import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "和", -1 /* HOISTED */)
const _hoisted_2 = { class: "box_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: $data.modal.show,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (($data.modal.show) = $event)),
    footer: null,
    wrapClassName: "modal_protocol",
    destroyOnClose: ""
  }, {
    default: _withCtx(() => [
      _createTextVNode(" 请先阅读并同意 "),
      _createVNode(_component_a_button, {
        type: "link",
        target: "_blank",
        href: _ctx.$Config.Protocol.user
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 《用户注册协议》 ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href"]),
      _hoisted_1,
      _createVNode(_component_a_button, {
        type: "link",
        target: "_blank",
        href: _ctx.$Config.Protocol.privacy
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 《隐私政策协议》 ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href"]),
      _createCommentVNode(" <span style=\"margin:0 -5px\">和</span>\n    <a-button type=\"link\" target=\"_blank\"\n              :href=\"$Config.Protocol.disclaimers\">\n      《免责声明》\n    </a-button> "),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { onClick: $options.close }, {
              default: _withCtx(() => [
                _createTextVNode(" 拒绝 ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: $options.clickSure
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 同意 ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible"]))
}